import React, { Component } from "react";
import Autocomplete, { usePlacesWidget } from "react-google-autocomplete";
window.React = React

export class TextInput extends Component {
  render() {
    const {
      label,
      id,
      className,
      placeholder,
      svg,
      viewBox,
      value,
      onChange,
      required,
      isValid,
      validationMessage,
      isGoogleAutoFill,
      onPlaceSelected,
      handlePhoneFormat
    } = this.props;

    let renderInput;
    let renderSvg;

    if (isGoogleAutoFill) {
      renderInput = <Autocomplete
        value={value}
        id={id}
        className={`ob-input__control ${svg ? "ob-input__control--svg" : ""
          } ${!isValid ? "ob-input--red" : ""}`}
        placeholder={placeholder}
        onChange={onChange}
        svg={svg}
        apiKey="AIzaSyDaOvJ8Ge8Qv9VtVXsJoDXjQGoizksBMuw"
        //onPlaceSelected={onPlaceSelected}
        onPlaceSelected={(selected, a, c) => {
          onPlaceSelected(selected);
        }}
        options={{
          types: ["geocode"],
          componentRestrictions: { country: ["us", "ca"] },
        }}
      />;
    }
    else {
      var keyDownAttr = { };
      if(id === "contactPhone"){
        keyDownAttr.onkeydown={handlePhoneFormat};
      }

      renderInput = <input
        type="text"
        value={value}
        id={id}
        className={`ob-input__control ${svg ? "ob-input__control--svg" : ""
          } ${!isValid ? "ob-input--red" : ""} ${isGoogleAutoFill ? "location-autocomplete" : ""}`}
        placeholder={placeholder}
        onChange={onChange}
        svg={svg}
        { ...keyDownAttr}
      />;
    }

    if (svg) {
      renderSvg = <svg
      className="ob-input__svg"
      aria-hidden="true"
      focusable="false"
      viewBox={viewBox}
    >
      <use xlinkHref={svg}></use>
    </svg>
    }

    return (
      <div className={className}>
        <div className="ob-input">
          {label && (
            <label
              htmlFor={id}
              className={`ob-input__label ${required ? "required" : ""}`}
            >
              {label}
            </label>
          )}
          <div className="ob-input__control-container">
            {renderInput}
            {renderSvg}
          </div>
        </div>
        {
          !isValid ? 
          (<div
            className={`validation-message validation-message--show form-error error-alert`}
            >
            {validationMessage}
          </div>) : 
          (null)
        }
        
      </div>
    );
  }
}

export default TextInput;
